import { render, staticRenderFns } from "./registerNext.vue?vue&type=template&id=bb626b50&scoped=true&"
import script from "./registerNext.vue?vue&type=script&lang=js&"
export * from "./registerNext.vue?vue&type=script&lang=js&"
import style0 from "./registerNext.vue?vue&type=style&index=0&id=bb626b50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb626b50",
  null
  
)

export default component.exports